import type { EditingAppSelection } from '../../../../src/apps/tracer/editing-base.mjs';

type AcceptedPreview = {
  threadId: string;
  live?: boolean;
  editingApp?: Readonly<EditingAppSelection> | null;
  savedApp?: { threadId: string; saved: EditingAppSelection };
};

/** Only an accepted descriptor names the live workspace's saved parent.
 * Undefined keeps an unresolved/foreign saved edit unavailable. */
export function previewEditingSelection(
  value: AcceptedPreview,
  threadId: string,
): Readonly<EditingAppSelection> | null | undefined {
  if (value.threadId !== threadId) return undefined;
  if (value.savedApp)
    return value.savedApp.threadId === threadId ? value.savedApp.saved : undefined;
  if (value.live !== true || !Object.hasOwn(value, 'editingApp')) return undefined;
  return value.editingApp;
}
